import { defineSlotRecipe } from '@chakra-ui/react';

export const accordionRecipe = defineSlotRecipe({
  slots: ['root', 'item', 'trigger', 'content'] as const,
  base: {
    root: {
      fontFamily: 'Lato, sans-serif',
    },
    item: {
      fontFamily: 'Lato, sans-serif',
    },
  },
});
